interface UserAnswer {
	[key: string]: string;
}

export const USER_ANSWER: UserAnswer = {
	slim: 'Slim',
	mid: 'Mid-sized',
	heavier: 'On a heavier side',
	overweight: 'Overweight',
	thin: 'Thin',
	toned: 'Toned',
	curvy: 'Curvy',
	smaller: 'Just a few sizes smaller',
	lose_weight: 'Lose weight',
	love_myself: 'Love yourself',
	gain_muscles: 'Gain muscle tone',
	gain_flexibility: 'IIncrease flexibility',
	gain_build_endurance: 'Build endurance',
	gain_healthier_life: 'Live a healthier life',
	beginner: 'Beginner',
	intermediate: 'Intermediate',
	advanced: 'Advanced',
	minimum: '2 times',
	normal: '3 times',
	maximum: '4 times',
	all: 'All-food diet',
	vegetarian: 'vegetarian',
	vegan: 'vegan',
	keto: 'keto',
	dontKnow: 'I don’t know',
	needs: 'My activity level is not good and needs improvement',
	habits: 'I try to practice healthy lifestyle habits',
};

export const USER_ANSWER_WORKTIME: UserAnswer = {
	minimum: 'Less than 10 mins',
	normal: '10-20 min',
	maximum: 'More than 20 min',
	undefined: 'Let Verv decide',
	decide: 'Let us decide',
};

export const USER_ANSWER_JOB: UserAnswer = {
	extra_low: 'Not active',
	low: 'Some activity',
	normal: 'Moderately active',
	maximum: 'Very active',
};

export const USER_ANSWER_SLEEP: UserAnswer = {
	minimum: 'I sleep less than 7 hours',
	extra_low: 'Less than 5 hours',
	low: '5-6 hours',
	normal: '7-8 hours',
	maximum: 'More than 8 hours',
};

export const USER_ANSWER_WATER: UserAnswer = {
	extra_low: 'I only have coffee or tea',
	low: 'About 2 glasses (16 oz)',
	normal: '2 to 6 glasses (16-48 oz)',
	maximum: 'More than 6 glasses',
};

export const USER_ANSWER_TYPICAL_DAY: UserAnswer = {
	office: 'At the office',
	walks: 'Daily long walks',
	physical: 'Physical work',
	home: 'Mostly at home',
};

export const USER_ANSWER_BODY_TYPE: UserAnswer = {
	apple: 'Apple-shaped',
	pear: 'Pear-shaped',
	square: 'Square-shaped',
	hourglass: 'Hourglass',
	triangle: 'Inverted triangle',
};

export const USER_ANSWER_LIFE_EVENT: UserAnswer = {
	vacation: 'Vacation',
	wedding: 'Wedding',
	summer: 'Summer',
	gathering: 'Family gathering',
	birthday: 'Birthday party',
	not: 'I don`t have a specific occasion',
	other: 'Other',
};

export const USER_ANSWER_STAY_ON_TRACK: UserAnswer = {
	improving: 'Improving health',
	immune: 'Boosting immune system',
	looking: 'Looking better',
	strength: 'Building strength and endurance',
	libido: 'Boosting libido',
};

export const USER_ANSWER_IF_LIFE_CHANGE: UserAnswer = {
	new_person: 'My life would do a complete 180 and I would be a brand new person',
	more_confident: 'I would be more confident and be able to do more',
	much_happier: 'I would be much happier and even take up new activities',
	ideal_weight: 'My life wouldn`t change',
};

export const USER_ANSWER_AILMENTS: UserAnswer = {
	diabetes: 'I have diabetes',
	asthma: 'I have asthma',
	diseases: 'I have joint diseases',
	none: 'None of the above',
};

export const USER_ANSWER_MEDICATIONS: UserAnswer = {
	vitamins: 'Vitamins',
	hormones: 'Hormones',
	antibiotics: 'Antibiotics',
	other: 'Other',
	none: 'I am not taking any medications',
};

export const USER_ANSWER_OB_GOAL: UserAnswer = {
	lose_weight: 'lose_weight',
	improve_health: 'improve_health',
	antibiotics: 'antibiotics',
	get_firm: 'get_firm',
	relieve_stress: 'relieve_stress',
};

export const USER_ANSWER_OB_PHYSICAL_BUILD: UserAnswer = {
	slim: 'slim',
	mid_sized: 'mid_sized',
	heavier: 'heavier',
	overweight: 'overweight',
};

export const USER_ANSWER_OB_WATER: UserAnswer = {
	coffee_tee: 'coffee_tee',
	'2_glasses': '<2_glasses',
	'2_6_glasses': '2-6_glasses',
	'7_10_glasses': '7-10_glasses',
	'10_glasses': '10+_glasses',
};

export const USER_ANSWER_AGE: UserAnswer = {
	18: '18-29',
	30: '30-39',
	40: '40-49',
	50: '50-59+',
};
